var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummarisation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.9238H4.27262V21.0008H1V17.9238H1Z",
    stroke: "#103559",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72656 17.9238H18.9989V21.0008H6.72656V17.9238Z",
    stroke: "#103559",
    strokeWidth: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5391H4.27262V15.616H1V12.5391H1Z",
    stroke: "#103559",
    strokeWidth: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72656 12.5391H18.9989V15.616H6.72656V12.5391Z",
    stroke: "#103559",
    strokeWidth: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.46094H4.27262V12.5379H1V9.46094H1Z",
    stroke: "#103559",
    strokeWidth: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72656 9.46094H18.9989V12.5379H6.72656V9.46094Z",
    stroke: "#103559",
    strokeWidth: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.07617H4.27262V7.15311H1V4.07617H1Z",
    stroke: "#103559",
    strokeWidth: 0.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72656 4.07617H18.9989V7.15311H6.72656V4.07617Z",
    stroke: "#103559",
    strokeWidth: 0.9
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H4.27262V4.07694H1V1H1Z",
    stroke: "#103559",
    strokeWidth: 0.9
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72656 1H18.9989V4.07694H6.72656V1Z",
    stroke: "#103559",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummarisation);
export default __webpack_public_path__ + "static/media/summarisation.724168924e15485d91d9e97769d6a0e0.svg";
export { ForwardRef as ReactComponent };